export default {
  icons: []
};
